// extracted by mini-css-extract-plugin
export default {"button":"Button_button__dXAUs","default":"Button_default__+E8pc","disabled":"Button_disabled__Bs2IT","ghost":"Button_ghost__d0x+e","sm":"Button_sm__SpEbe","lg":"Button_lg__+YLOL"};